<div class="container">
	<div class="mb-4">
		<label class="form-label fw-bold">Załącz plik (max {{ MAX_SIZE_MB }}MB):</label>
		<div class="container">
			<div class="row align-items-center">
				<mat-form-field subscriptSizing="dynamic" class="col-4">
					<mat-label>Zewnętrzny link</mat-label>
					<input matInput [(ngModel)]="externalUrlToAdd" />
				</mat-form-field>

				<button
					[disabled]="!externalUrlToAdd()"
					class="col-2"
					color="primary"
					mat-raised-button
					(click)="addFileWithExternalUrl()"
				>
					Dodaj
				</button>

				<div class="col-4">
					<input type="file" class="form-control" (change)="onFileSelected($event)" />
				</div>

				<button
					class="col-2"
					mat-raised-button
					color="primary"
					[disabled]="someFileIsInvalid()"
					(click)="save()"
				>
					Zapisz pliki
				</button>
			</div>
		</div>
	</div>
	@if (isLoading()) {
		<div class="h-315 d-flex justify-content-center align-items-center">
			<mat-spinner></mat-spinner>
		</div>
	} @else if (displayFiles().length) {
		<div #scrollContainer class="align-items-stretch g-3 row h-315 overflow-auto">
			@for (file of displayFiles(); let i = $index; track i) {
				<div [ngClass]="{ 'col-12': gridStyle() === 'list', 'col-6': gridStyle() === 'grid' }">
					<mat-card
						appearance="outlined"
						[ngClass]="{ 'flex-row': gridStyle() === 'list', 'flex-col': gridStyle() === 'grid' }"
						class="h-fit d-flex"
					>
						@if (file?.['createdBy']?.id === loggedUserId() || file.isNew) {
							<button
								mat-icon-button
								color="warn"
								class="remove-btn"
								aria-label="Usuń"
								(click)="removeFile(file)"
							>
								<i class="fa-solid fa-xmark"></i>
							</button>
						}
						<div
							[ngClass]="{ 'w-50': gridStyle() === 'list', 'w-100': gridStyle() === 'grid' }"
							class="text-truncate"
						>
							<h5 class="text-truncate me-3">
								@if (file.isNew && !!file.file) {
									{{ file.file['name'] }}
								} @else {
									@let href = file.file || file.externalUrl;
									<a [href]="href" target="_blank" rel="noopener noreferrer">{{ href }}</a>
								}
							</h5>
							<h6>
								<div class="d-flex align-items-center h-60">
									@if (file.isNew) {
										@if (!!file.file) {
											Rozmiar: {{ (file.file['size'] / 1024 / 1024).toFixed(2) + ' MB' }}
										}
									} @else {
										Utworzono: {{ file['createdAt'] | date: 'dd.MM.yyyy, HH:mm' }}<br />
										Utworzono przez: {{ file['createdBy']?.firstName }}
										{{ file['createdBy']?.lastName }}
									}
								</div>
							</h6>
						</div>

						<mat-form-field
							[ngClass]="{ 'w-50': gridStyle() === 'list', 'w-100': gridStyle() === 'grid' }"
							subscriptSizing="dynamic"
							appearance="fill"
							class="mt-2"
						>
							<mat-label>Notatka</mat-label>
							<textarea
								matInput
								required
								rows="3"
								[disabled]="!file.isNew"
								[ngModel]="file.note"
								(ngModelChange)="onNoteChange(file, $event)"
							></textarea>
						</mat-form-field>
					</mat-card>
				</div>
			}
		</div>
	} @else {
		<div class="alert alert-warning h-315 text-center align-content-center fs-3" role="alert">
			Brak dodanych plików
		</div>
	}
</div>
